"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (n) {
    return Array.from(Array(n).keys());
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/array/sequence.js
// module id = 578
// module chunks = 0